/**
 * Qué miniaturas de Creaciones muestran el indicador de carga después de traer una
 * página (ADR-2026-09-24-creaciones-miniaturas-colgadas-en-carga).
 *
 * El indicador de cada celda sólo se apaga con el `onLoad` de su <img>. Una <img> que
 * ya está montada con la misma URL no vuelve a disparar `onLoad`, así que marcarla de
 * nuevo la deja girando para siempre. Eso pasaba con el refetch silencioso (termina una
 * generación mientras el usuario mira la grilla): marcaba toda la página 1.
 *
 * - `reemplazar`: la grilla pasó por el esqueleto y todas las <img> son nuevas; se
 *   marcan todas las filas traídas y se descarta lo anterior.
 * - `sumar` (refetch silencioso, "cargar más"): se marcan sólo las filas que no están
 *   ya en pantalla y se conserva el estado del resto.
 */
export function miniaturasEnCarga(
  previo: Record<number, boolean>,
  traidas: Array<number | string>,
  enPantalla: Array<number | string>,
  modo: "reemplazar" | "sumar",
): Record<number, boolean> {
  if (modo === "reemplazar") {
    return Object.fromEntries(traidas.map((id) => [id, true]));
  }
  const montadas = new Set(enPantalla.map(String));
  const mapa: Record<number, boolean> = { ...previo };
  for (const id of traidas) {
    if (!montadas.has(String(id))) mapa[id as number] = true;
  }
  return mapa;
}
